import React from 'react'

import { Icon } from '@clientbase/clientbase-library'
import { Box, Tooltip } from '@mui/material'
import { RecurrenceAccountsPayable } from 'models/AccountsPayable'
import { useAccountsPayableContext } from 'templates/AccountsPayable/context'

import { ButtonRounded } from 'components/button'
import Can from 'components/Can'
import { RecurrenceExpensesDetails } from 'components/Modal/ModalDetailsExpenses'
import { Table } from 'components/Table'

import { theme } from 'styles/theme'

interface ExpensesDetailsPaymentProps {
  setNestedModalCycles: React.Dispatch<React.SetStateAction<boolean>>
  data: RecurrenceExpensesDetails
  getDetailsExpenses: (uuid: string) => Promise<void>
}
const ExpensesCicles = ({
  setNestedModalCycles,
  data,
  getDetailsExpenses
}: ExpensesDetailsPaymentProps) => {
  const { setExpenseDetailModal, expenseDetailModal } =
    useAccountsPayableContext()
  const statusMapper: Record<string, string> = {
    pending: 'Pendente',
    overdue: 'Vencida',
    paid: 'Paga',
    deleted: 'Cancelada'
  }
  const handleClickRow = (uuid: string) => {
    setExpenseDetailModal({ uuid: uuid, isOpen: expenseDetailModal.isOpen })

    setNestedModalCycles(true)

    getDetailsExpenses(uuid)
  }
  function convertToRows(data: RecurrenceAccountsPayable[]) {
    const rows = data?.map((item: RecurrenceAccountsPayable) => {
      const dueDate = item.dueDate

      const paidDate = item.datePaid
      return {
        uuid: item.uuid,
        dueDate,
        datePaid: item.datePaid ? paidDate : '',
        amountBilled: item.amountBilled,
        amountPaid: item.amountPaid,
        status: statusMapper[item.status],
        action: (
          <Can permission="accounts_payable:show">
            <Box>
              <Tooltip
                enterTouchDelay={0}
                arrow={true}
                placement="top"
                title="Detalhes da despesa"
              >
                <ButtonRounded
                  onClick={() => handleClickRow(item.uuid)}
                  variant="transparent"
                >
                  <Icon
                    icon="settings"
                    sx={{ color: theme.palette.neutral[200] }}
                  />
                </ButtonRounded>
              </Tooltip>
            </Box>
          </Can>
        )
      }
    })

    return rows
  }
  return (
    <Box maxHeight="200px" overflow="auto">
      <Table
        mobileCards
        handleChangePage={() => null}
        handleChangeRowsPerPage={() => null}
        header={[
          { id: 'dueDate', label: 'Vencimento' },
          { id: 'datePaid', label: 'Pagamento' },
          { id: 'amountBilled', label: 'Valor' },
          { id: 'amountPaid', label: 'Valor Pago' },
          { id: 'status', label: 'Status' },
          { id: 'actions', label: '' }
        ]}
        hiddePagination={true}
        page={1}
        rows={convertToRows(data.recurrenceDetails || [])}
        rowAction={(uuid) => handleClickRow(uuid)}
        rowsPerPage={Infinity}
        totalCount={0}
        select={{ useSelect: false }}
      />
    </Box>
  )
}

export default ExpensesCicles
